import { useCallback, useEffect, useRef, useState } from 'react';
import Axios from '../api/axios';
import { publishBandCount } from '../utils/browserBandNotification';

const EMPTY = { onay_sayisi: 0, cevap_sayisi: 0, genel_yetkili: false };
const POLL_MS = 60_000;

function normalize(data) {
  return {
    onay_sayisi: Number(data?.onay_sayisi) || 0,
    cevap_sayisi: Number(data?.cevap_sayisi) || 0,
    genel_yetkili: !!data?.genel_yetkili,
  };
}

export function useApprovalNotifications() {
  const [summary, setSummary] = useState(EMPTY);
  const mountedRef = useRef(true);

  const refresh = useCallback(async () => {
    try {
      const response = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}report/onay/ozet`);
      const next = normalize(response.data);
      if (mountedRef.current) setSummary(next);
      if (next.genel_yetkili) {
        publishBandCount('onay', next.onay_sayisi, {
          title: 'Onaylar',
          body: next.onay_sayisi === 1
            ? '1 onay bekliyor'
            : `${next.onay_sayisi} onay bekliyor`,
        });
      }
      publishBandCount('cevap', next.cevap_sayisi, {
        title: 'Onay cevapları',
        body: next.cevap_sayisi === 1
          ? '1 onay cevabı var'
          : `${next.cevap_sayisi} onay cevabı var`,
      });
      return next;
    } catch (_) {
      return EMPTY;
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    refresh();
    const timer = setInterval(refresh, POLL_MS);
    const onFocus = () => refresh();
    const onRefresh = () => refresh();
    window.addEventListener('focus', onFocus);
    window.addEventListener('approval-notifications-refresh', onRefresh);
    return () => {
      mountedRef.current = false;
      clearInterval(timer);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('approval-notifications-refresh', onRefresh);
    };
  }, [refresh]);

  return { summary, refresh };
}
